import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./Assests/Styles/index.scss";
import "react-select/dist/react-select.css";
import "react-datepicker/dist/react-datepicker.css";

ReactDOM.render(<App />, document.getElementById("root"));